import MmenuLight from 'mmenu-light';

function syncMobileMenuHeaderOffset() {
  const header = document.getElementById('header');
  if (!header) return;

  const { bottom } = header.getBoundingClientRect();
  document.documentElement.style.setProperty('--header-menu-offset', `${Math.ceil(bottom)}px`);
}

const MenuMobile = {
  setMenuMobile: function () {
    const mmenuWrapper = document.querySelector('#mm-menu-mobile');
    const openMenuButton = document.querySelector('[data-action="open-menu-mobile"]');

    if (!mmenuWrapper || !openMenuButton) return;

    const mmenu = new MmenuLight(mmenuWrapper);

    //precisa do navigation e do drawer
    const navigator = mmenu.navigation({
      title: 'Menu',
    });

    const drawer = mmenu.offcanvas();

    syncMobileMenuHeaderOffset();

    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(syncMobileMenuHeaderOffset, 100);
    });

    openMenuButton.addEventListener('click', (e) => {
      e.preventDefault();
      syncMobileMenuHeaderOffset();

      if (document.body.classList.contains('mm-ocd-opened')) {
        drawer.close();
      } else {
        drawer.open();
      }
    });

    const closeMenuButton = document.querySelector('[data-action="close-menu-mobile"]');

    closeMenuButton &&
      closeMenuButton.addEventListener('click', (e) => {
        e.preventDefault();

        drawer.close();
      });

    window.mmenu = drawer;
  },
  init: function () {
    const _this = this;

    _this.setMenuMobile();
  },
};

MenuMobile.init();
